export const ADD_COMMISSION_RATE = "ADD_COMMISSION_RATE";
export const FETCH_COMMISSION_RATES = "FETCH_COMMISSION_RATES";
